import styled from 'styled-components'
import {
  position,
  color,
  layout,
  space,
  flexbox,
  boxShadow,
  background,
  typography,
  ColorProps,
  border,
  TypographyProps,
  LayoutProps,
  SpaceProps,
  FlexboxProps,
  BorderProps,
  PositionProps,
  BackgroundProps,
  BoxShadowProps,
} from 'styled-system'

const Box = styled.div<
  ColorProps &
    TypographyProps &
    LayoutProps &
    SpaceProps &
    FlexboxProps &
    BorderProps &
    PositionProps &
    BackgroundProps &
    BoxShadowProps
>`
  ${color};
  ${layout};
  ${space};
  ${flexbox};
  ${typography};
  ${border};
  ${position};
  ${background};
  ${boxShadow};
`

export default Box
